import { PageDefinition } from '../../../config/shared/types/page';
import { DefaultPageContainer } from './DefaultPageContainer';
import { FullScreenPageContainer } from './FullScreenPageContainer';
import { FullScreenDialogPageContainer } from './FullScreenDialogPageContainer';
import { ContainerProps } from './types';

type Containers = Record<
  PageDefinition['type'],
  ({ children, pageDefinition }: ContainerProps) => JSX.Element
>;

export const CONTAINERS: Containers = {
  default: DefaultPageContainer,
  'full-screen': FullScreenPageContainer,
  'full-screen-dialog': FullScreenDialogPageContainer,
};
